// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconBoard = createRemixIcon('IconBoard', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.75.75h22.5v22.5H.75zm2.5 2.5v17.5h17.5V3.25zM5.5 6H11v12H5.5zm13 0H13v5.5h5.5z\" clip-rule=\"evenodd\"/>");
